import axios from "axios";
import { transformCartToDesiredArray } from "./checkoutFunction";
import { erase, getCookie } from "./cookieFunction";
import { getCountryCode, getPhoneNumber, handelNumber } from "./splitCountryCode";
export const getApplePayToken = async (
  appState: any,
  checkoutData: any,
  ApplePaySession: any,
  handleCloseAll: any,
  freezScreenState: any,
  alertMessageState: any,
  setBookingForm: any,
  setCart: any,
  navigate: any, 
  slug: any,
  goToAuth:any,
  otpIsRequired = false
) => {
  if (!ApplePaySession) {
    return;
  }
  let data = checkoutData;
  const request = {
    requiredShippingContactFields: [],
    countryCode: "KW",
    currencyCode: "KWD",
    merchantCapabilities: ["supports3DS"],
    supportedNetworks: ["visa", "masterCard", "amex", "discover"],
    total: {
      label: "Pay with Apple Pay",
      type: "final",
      amount: checkoutData?.total,
    },
  };

  const session = new ApplePaySession(6, request);
  console.log(session,"session");
  
  session.onvalidatemerchant = async (event: any) => {
    let merchantBackendUrl = `${process.env.REACT_APP_API_URL}/apple-pay/merchant-validation`;
    let appUrl = `${process.env.REACT_APP_APP_DOMAIN}`;
    let body = {
      validation_url: event.validationURL,
      domain: appUrl
    };
    fetch(merchantBackendUrl, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((merchantSession) => {
        session.completeMerchantValidation(merchantSession);
      })
      .catch((error) => console.log("erroronvalidatemerchant", error)); // We need to handle the error instead of just logging it to // console.
  }; // See "Providing Merchant Validation"



  session.onpaymentauthorized = async (event: any) => {
    // if (window.location.href.includes(urlPart)) {
    //   alert('session.onpaymentauthorized -- Start')
    // }
    console.log(event, "event_onpaymentauthorized");
    const token = await event.payment.token;
    let applePayCustomerInfo;

    if(event?.payment?.shippingContact){
  // const formatedNumber = handelNumber(event?.payment?.shippingContact?.phoneNumber);
    // const countryCode = getCountryCode(formatedNumber);
    // const phoneNumber = getPhoneNumber(formatedNumber, countryCode)
    // applePayCustomerInfo = await {
    //   name: event?.payment?.shippingContact?.givenName,
    //   number: event?.payment?.shippingContact?.phoneNumber.replaceAll("+" + countryCode, ""),
    //   email: event?.payment?.shippingContact?.emailAddress,
    //   countryCode: countryCode,
    // }
    }
 
  
    const guestName =
      appState?.userInfo?.userFirstName ||
      appState?.userInfo?.name ||
      appState?.loginValues?.fullName ||
      null;
    const guestNumber =
      appState?.userInfo?.number ||
      appState?.loginValues?.phoneNumber ||
      null;
    const guestEmail =
      appState?.userInfo?.email ||
      appState?.loginValues?.email ||
      null;
    const guestCountryCode =
      appState?.userInfo?.countryCode ||
      appState?.loginValues?.phoneCode ||
      null;

    let payload: any = {
      time_id: appState?.bookingForm?.bookingTimeInd,
      booking_date: appState?.bookingForm?.bookingDate,
      guests: appState?.bookingForm?.NoGuest,
      device_id: appState?.deviceId,
      extras: transformCartToDesiredArray(appState.cart),
      payment_source: "apple_pay",
      apple_pay_token: token.paymentData,
    };

    if (!otpIsRequired) {
      payload.name = guestName;
      payload.number = guestNumber;
      payload.countryCode = guestCountryCode;
      if (guestEmail) {
        payload.email = guestEmail;
      }
    }

    const headers: any = {};
    if (otpIsRequired && getCookie("tokenAuth")) {
      headers.Authorization = `Bearer ${getCookie("tokenAuth")}`;
    }

    await axios
      .post(`${process.env.REACT_APP_API_URL}/booking/customer/add`, payload, {
        headers,
      })
      .then((response) => {
        if (response != null) {
          if (
            response.data.success === true &&
            response.data.data.url &&
            response.data.data.url != null
          ) {
            const winUrl: any = window.open(`${response.data.data.url}`, "_self");
            winUrl.focus();
            session.completePayment({
              status: ApplePaySession.STATUS_SUCCESS,
            });
          } else {
            if (response.data.success === true) {
              navigate(`/${slug}`);
              alertMessageState({
                type: "success",
                show: true,
                message: response?.data?.message,
              });
              freezScreenState(false);
              setBookingForm(null);
              setCart([]);
              session.completePayment({
                status: ApplePaySession.STATUS_SUCCESS,
              });
            } else {
              freezScreenState(false);

              alertMessageState({
                type: "SHOW_ALERT",
                alertType: "error",
                message: response.data.message,
              });
            }
            navigate("/");
            session.completePayment({
              status: ApplePaySession.STATUS_FAILURE,
            });
          }
        } else {
          freezScreenState(false);
          navigate("/");
          session.completePayment({
            status: ApplePaySession.STATUS_FAILURE,
          });
        }
      })
      .catch((error) => {
        console.log('api catch', error)
        // if (window.location.href.includes(urlPart)) {
        //   alert('api catch -- Start')
        // }
        freezScreenState(false)
        handleCloseAll();
        if(error.response.status == 401){
          erase("tokenAuth");
          erase("Profile");

          goToAuth()
          }
        if (error !== undefined) {
          console.log(error)
        } else {
          alertMessageState({
            type: "error",
            show: true,
            message: "Please check your network.",
          });
        }
        freezScreenState(false)
        handleCloseAll();
        session.completePayment({
          status: ApplePaySession.STATUS_FAILURE,
          errors: [error.toString()],
        });
      });


  }

  session.oncancel = (event: any) => {
    console.log('oncancle 1', event)
    handleCloseAll();
    freezScreenState(false)
    console.log('oncancle 2', event)
    session.completePayment({
      status: ApplePaySession.STATUS_FAILURE,
    });
  };

  session.begin();


}
